/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type AdditionalAddressFragmentFragment = { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string };

export type AdditionalCompanyInfoFragmentFragment = { delivery_description: string | null, delivery_instructions: string | null, delivery_email: string | null, delivery_phone_number: string | null, invoicing_instructions: string | null, invoicing_email: string | null, invoicing_phone_number: string | null, delivery_zones: Array<{ id: string, index: number, minimum_order_value: number, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, negotiable_minimum_order_value: boolean, delivery_time: number | null, administrative_areas: Array<{ area: string }> }>, delivery_hours: Array<{ id: string, opening_hour: string, closing_hour: string, week_day: string }>, delivery_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null, invoicing_address: { id: string, address_1: string, address_2: string | null, postal_code: string, city: string, country: string, name: string } | null };

export const AdditionalAddressFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment additionalAddressFragment on additional_address {
  id
  address_1
  address_2
  postal_code
  city
  country
  name
}
    `;
export const AdditionalCompanyInfoFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment additionalCompanyInfoFragment on company {
  delivery_description
  delivery_zones(order_by: {index: asc}) {
    id
    index
    minimum_order_value
    minimum_order_value_type
    administrative_areas {
      area
    }
    negotiable_minimum_order_value
    delivery_time
  }
  delivery_hours {
    id
    opening_hour
    closing_hour
    week_day
  }
  delivery_instructions
  delivery_email
  delivery_phone_number
  delivery_address {
    ...additionalAddressFragment
  }
  invoicing_instructions
  invoicing_email
  invoicing_phone_number
  invoicing_address {
    ...additionalAddressFragment
  }
}
    ${AdditionalAddressFragmentFragmentDoc}`;